import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CustomerBillingPage } from './customer-billing';

@NgModule({
  declarations: [
    CustomerBillingPage,
  ],
  imports: [
    IonicPageModule.forChild(CustomerBillingPage),
  ],
})
export class CustomerBillingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/customer-billing/customer-billing.module.ts